import { DateTime } from "luxon";

/** ISO-like timestamp safe for filenames (no colons/dots). Includes seconds. */
export const getFilenameTimestamp = (): string => {
  const iso = DateTime.now().toISO();
  if (!iso) return "";
  return iso.slice(0, 19).replace(/[:.]/g, "-");
};
